module.exports = __webpack_public_path__ + "static/assets/46660e8b059a26e8f35aeb8f87fd6ebf.svg";